<template>
  <div v-if="dataSource.series[0].data.length">
    <MixedCarts :dataSource="dataSource" v-if="stepSelected" />
  </div>
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "StepA1",
  components: {
    MixedCarts,
  },
  props: {
    stepSelected: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      elements: {
        questions: [
          "order",
          "informations_before_command",
          "the_box_by_exception",
        ],
        post_command: [
          "order_follow",
          "return",
          "modification",
          "annulation",
          "defective_article",
          "stock_rupture",
          "missing_products",
          "error_product",
          "find_return_coupon",
          "invoice",
          "contact_customer_service",
        ],
        informations_before_command: [
          "delivery",
          "return_reimbursement",
          "payment",
          "loyalty_program",
          "sizes_cuts",
          "availability_products",
          "stock_alert",
          "gift_card",
          "kadeos",
          "gift_box",
          "contact_customer_service",
        ],
        the_box_by_exception: [
          "box_process",
          "box_order",
          "box_frequency",
          "box_stylist",
          "box_delivery",
          "box_return",
          "box_cost",
        ],
        carrier: [
          "delivery_france",
          "delivery_DOM_TOM",
          "delivery_europe",
          "delivery.outside_europe",
        ],
        follow: ["box_order"],
        return: ["metropolitan_france", "european_country"],
        delivery: ["estimated_delivery_date", "carrier", "urgency"],
        return_reimbursement: [
          "returns_conditions",
          "return_cost",
          "shop_return",
          "reimbursement_condition",
          "exchange_conditions",
        ],
        payment: [
          "security_payment",
          "3_or_4_times_without_charge",
          "try_buy",
          "paypal",
          "currency_payment",
          "bank_transfer_payment",
        ],
        loyalty_program: [
          "how_works",
          "point_expiration",
          "use_conditions",
          "coupon_annulation",
          "use_coupon",
          "advantages_ambassador",
        ],
        gift_card: [
          "offer_gift_card",
          "time_limits_gift_card",
          "condition_use",
          "problem_card",
          "how_use_gift_card",
        ],
      },
      dataSource: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#33b2df"],
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  mounted() {
    let res = [];
    if (this.onboarding) {
      for (const [key, value] of Object.entries(this.onboarding)) {
        if (this.elements[this.stepSelected].includes(key)) {
          const temp = key === "order" ? "post_command" : key;
          res.push({
            x: this.store_config.i18n[this.$i18n.locale].buttons[temp]
              ? this.store_config.i18n[this.$i18n.locale].buttons[temp].split(
                  "&"
                )[0]
              : this.store_config.i18n[this.$i18n.locale].buttons[temp] || temp,
            y: value,
          });
        }
      }
      this.dataSource.series[0].data = res.sort(function (a, b) {
        return b.y - a.y;
      });
    }
  },
};
</script>
